import { render, staticRenderFns } from "./SeatPlan.vue?vue&type=template&id=2444a563&scoped=true&"
import script from "./SeatPlan.vue?vue&type=script&lang=js&"
export * from "./SeatPlan.vue?vue&type=script&lang=js&"
import style0 from "./SeatPlan.vue?vue&type=style&index=0&id=2444a563&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2444a563",
  null
  
)

export default component.exports